export const STATUS_DRAFT = 'Draft';
export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_IN_TEST = 'In-test';
